<style>
  [tuiButton][data-appearance='flat'] {
    --tui-padding: 0.5rem;
  }
  hr {
    border-bottom: 1px solid var(--x-color-gray);
  }
  .block-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    padding: 1rem;
  }
</style>

<ng-container
  [ngTemplateOutlet]="groupActionButtonTemplate"
  [ngTemplateOutletContext]="{
    title: 'group_actions.title.status' | translate,
    buttons: [
      {
        name: 'group_actions.actions.change_status' | translate,
        view: GroupActionsViewsTypes.ChangeStatus,
      },
    ],
  }"
/>
@if (canLogistViewAllRequests$ | async) {
  <ng-container
    [ngTemplateOutlet]="groupActionButtonTemplate"
    [ngTemplateOutletContext]="{
      title: 'group_actions.title.release_date' | translate,
      buttons: [
        {
          name: 'group_actions.actions.change_release_date' | translate,
          view: GroupActionsViewsTypes.ChangeReleaseDate,
        },
      ],
    }"
  />
}
<ng-container
  [ngTemplateOutlet]="groupActionButtonTemplate"
  [ngTemplateOutletContext]="{
    title: 'group_actions.title.comments' | translate,
    buttons: [
      {
        name: 'group_actions.actions.add_deal_details' | translate,
        view: GroupActionsViewsTypes.AddDealDetails,
      },
      {
        name: 'group_actions.actions.ratings' | translate,
        view: GroupActionsViewsTypes.InternalRatings,
      },
    ],
  }"
/>
<ng-container
  [ngTemplateOutlet]="groupActionButtonTemplate"
  [ngTemplateOutletContext]="{
    title: 'group_actions.title.delivery_address' | translate,
    buttons: [
      {
        name: 'group_actions.actions.confirm_delivery_address' | translate,
        view: GroupActionsViewsTypes.ConfirmActualDeliveryAddress,
      },
      {
        name: 'group_actions.actions.reset_delivery_address' | translate,
        action: performResettingActualDeliveryAddress.bind(this),
      },
    ],
  }"
/>
@if (canLogistChangeInstaller$ | async) {
  <ng-container
    [ngTemplateOutlet]="groupActionButtonTemplate"
    [ngTemplateOutletContext]="{
      title: 'group_actions.title.installer_assignment' | translate,
      buttons: [
        {
          name: 'group_actions.actions.change_installer_assignment' | translate,
          view: GroupActionsViewsTypes.InstallerAssignment,
          disabled: !canOpenInstallerAssignmentAction(),
          hint: installerAssignmentBlockedReasonKey(),
        },
      ],
    }"
  />
}
@if (canUploadFiles$ | async) {
  <ng-container
    [ngTemplateOutlet]="groupActionButtonTemplate"
    [ngTemplateOutletContext]="{
      title: 'group_actions.title.files' | translate,
      buttons: [
        {
          name: 'group_actions.actions.upload_files' | translate,
          view: GroupActionsViewsTypes.UploadFiles,
        },
      ],
    }"
  />
}

<ng-template #groupActionButtonTemplate let-title="title" let-buttons="buttons">
  <div class="x-card x-card_size_s x-white mt-2 p-0">
    <h3 class="block-title ms-2.5">{{ title }}</h3>
    @for (button of buttons; track button.name; let last = $last) {
      <hr />
      <div class="x-card__paragraph">
        <button
          tuiButton
          appearance="flat"
          type="button"
          [ngClass]="last ? 'rounded-t-none!' : 'rounded-none!'"
          class="h-auto! min-h-11 w-full overflow-visible whitespace-normal p-0"
          [disabled]="button.disabled"
          (click)="
            button.action ? button.action() : $viewChanged.emit(button.view)
          "
        >
          <span class="x-text-01 flex min-w-0 w-full justify-between">
            <span
              class="font-medium min-w-0 flex-1 break-words whitespace-normal p-2 ms-2.5 text-start"
            >
              <span class="block">
                {{ button.name }}
              </span>
              @if (button.hint) {
                <span
                  class="block break-words whitespace-normal x-font-caption-1 text-(--x-color-danger)"
                >
                  {{ button.hint | translate }}
                </span>
              }
            </span>
            @if (button.view) {
              <tui-icon
                icon="@tui.chevron-right"
                class="mt-2 me-4 shrink-0"
              ></tui-icon>
            }
          </span>
        </button>
      </div>
    }
  </div>
</ng-template>
